import { z } from 'zod';
export const Strada_Set_Variable_1_ConfigValidator = z.object({
    variables: z.record(z.string(), z.any())
});
//# sourceMappingURL=strada-set-variable-1.js.map